<template>
  <div
    v-if="showAppVersion"
    class="app-version bg-EXPONDO-red text-center z-10 relative"
  >
    <span class="text-EXPONDO-white">
      App version: {{ appVersion }}
    </span>
  </div>
</template>

<script lang="ts">

import { APP_SHOW_VERSION_QUERY_PARAM } from '~~/constants/appVersion';
import { StringBoolean } from '~~/types/StringBoolean';
import { getApplicationVersion } from '~~/helpers/applicationVersion';

export default defineComponent({
  setup() {

    const $config = useRuntimeConfig();
    const route = useRoute();

    const appTag = $config.public.TAG;
    const appEnvironment = $config.public.applicationEnvironment;

    const appVersion = computed(() => {

      return getApplicationVersion(appEnvironment, appTag);
    
    });

    const showAppVersion = computed(() => {

      return route.query[APP_SHOW_VERSION_QUERY_PARAM] === StringBoolean.true;
    
    });

    return {
      appVersion,
      showAppVersion,
    };
  
  },
});

</script>
